import React from 'react';
import './four-zero-error.css';

const NotFoundPage: React.FC = () => {
    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <h1 className="error-code">404</h1>
                <p className="error-message">So sorry, we couldn't find what you were looking for...</p>
                {/* <a href="/" className="back-home-btn">Back to the homepage</a> */}
            </div>
            {/* <div className="start-using">
                <p>Start using <strong>yourservice.com</strong> today</p>
                <a href="/" className="get-started-btn">Get Started →</a>
            </div> */}
        </div>
    );
};

export default NotFoundPage;
